export const getGameCodeUrlParam = () => {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  return parseInt(urlParams.get('gameCode') ?? '0') ?? null
}

export const removeGameCodeUrlParam = () => {
  const url = new URL(location.href)
  url.searchParams.delete('gameCode')
  window.history.replaceState({}, document.title, url)
}
